import axiosInstance from './config/api';

type CallsToAgentRatio = {
    message: string;
};

export const putCallsToAgentRatio = (id: string, ratio: number) => {
    return axiosInstance
        .put<CallsToAgentRatio>(`/workflows/calls-to-agent-ratio/${id}`, {
            callsToAgentRatio: ratio,
        })
        .then((resp) => resp.data);
};
